import { render, staticRenderFns } from "./RequestNewGroup.vue?vue&type=template&id=28078a0f&scoped=true&"
import script from "./RequestNewGroup.vue?vue&type=script&lang=js&"
export * from "./RequestNewGroup.vue?vue&type=script&lang=js&"
import style0 from "./RequestNewGroup.vue?vue&type=style&index=0&id=28078a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28078a0f",
  null
  
)

export default component.exports